import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site";

export const WhatsAppFloat = () => (
  <motion.a
    href={WHATSAPP_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="floating-whatsapp-btn"
    aria-label="Contattaci su WhatsApp"
    initial={{ opacity: 0, scale: 0.5, y: 20 }}
    animate={{ opacity: 1, scale: 1, y: 0 }}
    transition={{ delay: 1.6, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    className="group fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-[#25D366] py-3.5 pl-4 pr-5 text-white shadow-2xl shadow-green-500/40 transition-transform duration-300 hover:scale-105"
  >
    <span className="absolute inset-0 -z-10 animate-ping-slow rounded-full bg-[#25D366]/50" />
    <MessageCircle className="h-6 w-6 fill-white/20" />
    <span className="flex flex-col leading-tight">
      <span className="text-sm font-bold">Scrivici ora</span>
      <span className="text-[11px] text-green-100">Rispondiamo subito</span>
    </span>
  </motion.a>
);
